import { cB as t } from "./ghl-ui.es384.js";
const n = t("dynamic-tags", [t("input", {
  minWidth: "var(--n-input-width)"
})]);
export {
  n as default
};
